import React from "react";
import { useTranslation } from "react-i18next";
import {
  UpperSection,
  Text,
  FormWrapper,
  FormImage,
  Form,
  ContactUs,
  Label,
  Input,
  TextArea,
  Button,
  LowerWrapper,
  LowerSection,
  DownloadSection,
  ContactsSection,
  TextLowerFooter,
  ButtonLink,
  AppleFooterButton,
  GoogleFooterButton,
  ContactsWrapper,
  InputWrapper,
  Contacts,
  Email,
  Tel,
  SocialUpWrapper,
  SocialWrapper,
  SocialLink,
  ContactsTitle,
  SocialIcon,
  UpWrapper,
  ArrowFooter,
  Up,
} from "./Footer.styles";
import heart from "../../assets/images/heart.svg";
import useFooter from "./Footer.utils";
import arrowFooter from "../../assets/images/arrowFooter.svg";
import facebook from "../../assets/images/facebook.svg";
import instagram from "../../assets/images/instagram.svg";
import footerRightSide from "../../assets/images/footerRightSide.svg";
import footerLeftSide from "../../assets/images/footerLeftSide.svg";
import Modal from "../Modal/Modal";
import Validation from "../../constants/validation";

const Footer = () => {
  const {
    buttonGoogle,
    buttonApple,
    googleHovered,
    googleUnhovered,
    appleHovered,
    appleUnhovered,
    width,
    scroll,
    name,
    changeName,
    nameError,
    send,
    email,
    changeEmail,
    emailError,
    phone,
    changePhone,
    phoneError,
    message,
    changeMessage,
    messageError,
    showModal,
  } = useFooter();
  const {
    nameValidation,
    emailValidation,
    phoneValidation,
    messageValidation,
  } = Validation();

  const { t } = useTranslation();
  const nameValidate = nameValidation(name);
  const emailValidate = emailValidation(email);
  const phoneValidate = phoneValidation(phone);
  const messageValidate = messageValidation(message);

  const existTranslate = ({ t: key }) => t(key) !== key;
  return (
    <>
      <UpperSection>
        <Text>{t("becomeParents")}</Text>
        <img src={heart} alt="heart" />
      </UpperSection>
      <FormWrapper>
        {width > 767 && (
          <FormImage src={footerLeftSide} alt="footer right side" />
        )}
        <Form>
          <ContactUs>{t("contactUs")}</ContactUs>
          <InputWrapper>
            {nameError && <Label for="inputName">{nameValidate}</Label>}
            {existTranslate({ t: "name" }) && (
              <Input
                id="inputName"
                placeholder={t("name")}
                type="text"
                value={name}
                onChange={changeName}
                error={nameError}
              />
            )}
          </InputWrapper>
          <InputWrapper>
            {emailError && <Label for="inputEmail">{emailValidate}</Label>}
            {existTranslate({ t: "email" }) && (
              <Input
                id="inputEmail"
                placeholder={t("email")}
                type="email"
                value={email}
                onChange={changeEmail}
                error={emailError}
              />
            )}
          </InputWrapper>
          <InputWrapper>
            {phoneError && <Label for="inputPhone">{phoneValidate}</Label>}
            {existTranslate({ t: "phone" }) && (
              <Input
                id="inputPhone"
                placeholder={t("phone")}
                type="tel"
                value={phone}
                onChange={changePhone}
                error={phoneError}
              />
            )}
          </InputWrapper>
          <InputWrapper>
            {messageError && (
              <Label for="inputMessage">{messageValidate}</Label>
            )}
            {existTranslate({ t: "message" }) && (
              <TextArea
                placeholder={t("message")}
                value={message}
                onChange={changeMessage}
                error={messageError}
              />
            )}
          </InputWrapper>
          <Button onClick={send}>{t("send")}</Button>
          {showModal && <Modal />}
        </Form>
        {width > 767 && (
          <FormImage src={footerRightSide} alt="footer right side" />
        )}
      </FormWrapper>
      <LowerWrapper>
        <LowerSection>
          <DownloadSection>
            <TextLowerFooter>{t("download")} KidHab</TextLowerFooter>
            <ButtonLink
              href="https://apps.apple.com/ua/app/kidhab/id1550279631"
              target="_blank"
              rel="noreferrer"
            >
              <AppleFooterButton
                src={buttonApple}
                alt="apple footer"
                onMouseEnter={appleHovered}
                onMouseLeave={appleUnhovered}
              />
            </ButtonLink>
            <ButtonLink
              href="https://play.google.com/store/apps/details?id=com.kidhab"
              target="_blank"
              rel="noreferrer"
            >
              <GoogleFooterButton
                src={buttonGoogle}
                alt="google footer"
                onMouseEnter={googleHovered}
                onMouseLeave={googleUnhovered}
              />
            </ButtonLink>
          </DownloadSection>
          <ContactsSection>
            <ContactsTitle>{t("contacts")}</ContactsTitle>
            <ContactsWrapper>
              <Contacts>{t("address")}</Contacts>
              <Email href="mailto:name@email.com">kidhab@goit.ua</Email>
              <Contacts>
                <Tel href="tel:050-366-17-77">095 478 80 38</Tel>
                <br />
                <Tel href="tel:067-326-95-92">095 113 85 98</Tel>
              </Contacts>
            </ContactsWrapper>
          </ContactsSection>
          <SocialUpWrapper>
            <SocialWrapper>
              <SocialLink
                href="https://www.facebook.com/KidHab"
                target="_blank"
                rel="noreferrer"
              >
                <SocialIcon src={facebook} alt="facebook" />
              </SocialLink>
              <SocialLink
                href="https://www.instagram.com/kid.hab/"
                target="_blank"
                rel="noreferrer"
              >
                <SocialIcon src={instagram} alt="instagram" />
              </SocialLink>
            </SocialWrapper>
            <UpWrapper onClick={scroll}>
              <ArrowFooter src={arrowFooter} alt="arrow footer" />
              <Up>Up</Up>
            </UpWrapper>
          </SocialUpWrapper>
        </LowerSection>
      </LowerWrapper>
    </>
  );
};

export default Footer;
